import {
    CREAR_TURNO,
    CREAR_TURNO_EXITO,
    CREAR_TURNO_ERROR
} from '../types';
import { actualizarTurnosAction } from './editarTurnoActions';
import clienteAxios from '../config/axios';

// Mando al store los datos de residencia
export function crearTurnoAction(informacion) {
    return async (dispatch) => {
        dispatch( crearTurno() );
        try {
            const {config, payload} = informacion;
            const respuesta = await clienteAxios.post('/paciente/crearturno', payload,config);
            dispatch(crearTurnoExito(respuesta.data));
            return respuesta.data;
        } catch (error) {
            const mensajeError =
                error.response?.data?.msg ||
                error.response?.data?.message ||
                error.response?.data?.error ||
                'No se pudo crear el turno';

            dispatch(crearTurnoError(mensajeError));

            // Guardamos el mensaje en el error para usarlo en Calendario.js.
            error.userMessage = mensajeError;

            // CLAVE:
            // Volvemos a lanzar el error para que Calendario.js entre al catch.
            throw error;
        }
    }
}

const crearTurno = () => ({
    type: CREAR_TURNO,
    payload: true
});
const crearTurnoExito = (data) => ({
    type: CREAR_TURNO_EXITO,
    payload: data
});
const crearTurnoError = (msg) => ({
    type: CREAR_TURNO_ERROR,
    payload: msg
});
